import { Controller } from '@hotwired/stimulus';
import { AddressForm } from '../../form/components/address_form';

export default class extends Controller {
  static targets = [
    'switchLink',
  ];

  static values = {
    mapApiKey: String,
    latitude: Number,
    longitude: Number,
    img: String,
    countryCodes: String,
  };

  connect() {
    const addressForm = new AddressForm(
      this.mapApiKeyValue,
      this.imgValue,
      this.latitudeValue,
      this.longitudeValue,
      this.countryCodesValue
    );

    if (this.hasSwitchLinkTarget) {
      this.switchLinkTarget.addEventListener('click', (event) => { this.switchMode(event); });
    }

    setTimeout(function() {
      const $geoAddressCityInput = $('#geo-address-city-input');

      if ($('#address-full-input').isInViewport() || ($geoAddressCityInput.length && $geoAddressCityInput.isInViewport())) {
        addressForm.init();
      } else {
        // needs to be done on click as well as the map may not be shown at the load of the page
        // and will bug if not initialized
        $('.new-listing-address__radio').one('click', function() {
          addressForm.init();
        });
      }
    }, 250);
  }

  switchMode(event) {
    event.preventDefault();

    const searchInputContainer = event.target.closest('#search-input-container');
    if (!searchInputContainer) return;

    const autoSearch = searchInputContainer.querySelector('.auto-search');
    const manualSearch = searchInputContainer.querySelector('.manual-search');

    if (!autoSearch.classList.contains('d-none')) {
      autoSearch.classList.add('d-none');
    }

    manualSearch.classList.remove('d-none');
  };
}
